import { EnvironmentService } from 'services/EnvironmentService';
import { ToBuildAProfileLoginPageTemplate } from '../login/template/2bap/2bapLoginPageTemplate';
import { DefaultSecurityPageTemplate } from './templates/defaultTemplate';
import { has } from 'lodash';

var SecurityStore = require('../../store/securityStore'),
  SecurityAction = require('../../action/securityAction');

var NotFountPage = require('../notFound/notFoundPage');


var Actions = require('./actions');

var SecurityPage = React.createClass({

  contextTypes: {
    router: React.PropTypes.object
  },

  getInitialState(){
    var action = this._getAction(),
      isTokenInvalid = (this._isValidateTokenAction(action) && !this._getToken());

    return {
      error: null,
      resetToken: null,
      activateToken: null,
      isTokenInvalid: isTokenInvalid,
      isValidationInProcess: false
    }
  },

  componentWillMount(){
    SecurityStore.addChangeListener(SecurityStore.ERROR_EVENT, this._onError);
    SecurityStore.addChangeListener(SecurityStore.PASSWORD_RESET, this._onPasswordReset);
    SecurityStore.addChangeListener(SecurityStore.PASSWORD_RESET_TOKEN_VALID, this._onPasswordResetValidToken);
    SecurityStore.addChangeListener(SecurityStore.PASSWORD_RESET_TOKEN_INVALID, this._onPasswordResetInvalidToken);
    SecurityStore.addChangeListener(SecurityStore.ACTIVATE_ACCOUNT_TOKEN_VALID, this._onActivateAccountValidToken);
    SecurityStore.addChangeListener(SecurityStore.ACTIVATE_ACCOUNT_TOKEN_INVALID, this._onActivateAccountInvalidToken);
    SecurityStore.addChangeListener(SecurityStore.PASSWORD_SAVED, this._onPasswordSaved);
    SecurityStore.addChangeListener(SecurityStore.ACCOUNT_ACTIVATED, this._onAccountActivated);

    this._checkToken();
  },

  componentWillUnmount(){
    SecurityStore.removeChangeListener(SecurityStore.ERROR_EVENT, this._onError);
    SecurityStore.removeChangeListener(SecurityStore.PASSWORD_RESET, this._onPasswordReset);
    SecurityStore.removeChangeListener(SecurityStore.PASSWORD_RESET_TOKEN_VALID, this._onPasswordResetValidToken);
    SecurityStore.removeChangeListener(SecurityStore.PASSWORD_RESET_TOKEN_INVALID, this._onPasswordResetInvalidToken);
    SecurityStore.removeChangeListener(SecurityStore.ACTIVATE_ACCOUNT_TOKEN_VALID, this._onActivateAccountValidToken);
    SecurityStore.removeChangeListener(SecurityStore.ACTIVATE_ACCOUNT_TOKEN_INVALID, this._onActivateAccountInvalidToken);
    SecurityStore.removeChangeListener(SecurityStore.PASSWORD_SAVED, this._onPasswordSaved);
    SecurityStore.removeChangeListener(SecurityStore.ACCOUNT_ACTIVATED, this._onAccountActivated);
  },

  _onError(err){
    this.setState({error: err});
  },

  _onAccountActivated(){
    this._redirectToAction(Actions.Type.ACTIVATE_ACCOUNT_RESULT);
  },

  _onPasswordReset(){
    this._redirectToAction(Actions.Type.EMAIL_SENT);
  },

  _onPasswordSaved(){
    this._redirectToAction(Actions.Type.PASSWORD_SAVED_ACTION);
  },

  _onPasswordResetValidToken(){
    this.setState({
      isValidationInProcess: false,
      resetToken: SecurityStore.getResetPasswordToken()
    });
  },

  _onPasswordResetInvalidToken(){
    this.setState({
      isValidationInProcess: false,
      isTokenInvalid: true
    });
  },

  _onActivateAccountValidToken(){
    this.setState({
      isValidationInProcess: false,
      activateToken: SecurityStore.getActivateAccountToken()
    });
  },

  _onActivateAccountInvalidToken(){
    this.setState({
      isValidationInProcess: false,
      isTokenInvalid: true
    });
  },

  render(){
    if (this.state.isValidationInProcess) {
      /*TODO: return loader probably*/
      return null;
    }

    const ActionShape = this._getActionShape();

    if (!ActionShape) {
      return <NotFountPage t={this.props.t}/>
    }

    const env = new EnvironmentService();

    return env.is2bap
      ? <ToBuildAProfileLoginPageTemplate>{ActionShape}</ToBuildAProfileLoginPageTemplate>
      : <DefaultSecurityPageTemplate>{ActionShape}</DefaultSecurityPageTemplate>
  },

  _getTitle(){
    var {t} = this.props;
    return (
      <h1 className="login-header-big txt-color-white">
        {t("Improving the quality of children's reading")}
      </h1>
    );
  },

  _getError(){
    var {error} = this.state;
    return error;
  },

  _getActionShape(){
    const action = this._getAction();
    const ActionClass = Actions.components[action];

    if (!ActionClass || !action) {
      return null;
    }

    return this._createShape(action, ActionClass);
  },

  _createShape(action, ActionClass){
    var {t} = this.props;
    var props = {
      t: t
    };

    switch (action) {
      case Actions.Type.FORGOT_PASSWORD:
        props.onSubmit = this.resetPasswordSendEmailHandler;
        props.error = this._getError();
        break;
      case Actions.Type.EMAIL_SENT:

        break;
      case Actions.Type.RESET_PASSWORD:
        props.onSubmit = this.resetPasswordHandler;
        props.invalidToken = this.state.isTokenInvalid;
        props.error = this._getError();
        break;
      case Actions.Type.ACTIVATE_ACCOUNT:
        props.onSubmit = this.activateAccountHandler;
        props.invalidToken = this.state.isTokenInvalid;
        props.organisationName = this._getOrganisationName();
        props.isParent = this._isParent();
        props.error = this._getError();
        break;
      case Actions.Type.ACTIVATE_ACCOUNT_RESULT:

        break;
      case Actions.Type.PASSWORD_SAVED_ACTION:

        break;
      default:
        return null;
    }

    return (<ActionClass {...props} />);
  },


  //<editor-fold desc="[handlers]">
  resetPasswordSendEmailHandler(data){
    SecurityAction.resetPassword(data);
  },

  resetPasswordHandler(data){
    var {resetToken} = this.state;
    if (resetToken) {
      SecurityAction.saveNewPassword(data, resetToken);
    }
  },

  activateAccountHandler(data){
    var {activateToken} = this.state;
    if (activateToken) {
      SecurityAction.activateAccount(data, activateToken);
    }
  },
  //</editor-fold>

  _redirectToAction(action){
    var {route} = this.props;
    var url = route.path.replace(':action', action);
    this.context.router.push(url);
  },

  _checkToken(){
    var action = this._getAction(),
      token = this._getToken();

    if (!token) {
      return;
    }

    if (this._isValidateTokenAction(action)) {
      if (action == Actions.Type.RESET_PASSWORD) {
        SecurityAction.validateResetPasswordToken(token);
      } else if (action == Actions.Type.ACTIVATE_ACCOUNT) {
        SecurityAction.validateActivateAccountToken(token);
      }

      this.setState({isValidationInProcess: true});
    }

  },

  _isValidateTokenAction(action){
    return (action == Actions.Type.RESET_PASSWORD
    || action == Actions.Type.ACTIVATE_ACCOUNT);
  },

  _getToken(){
    var {query} = this.props.location;
    return (!query || !query.token) ? null : query.token;
  },

  _getOrganisationName() {
    const { query } = this.props.location;
    return query && query.org;
  },
  
  _isParent() {
    return has(this.props.location.query, 'isParent');
  },

  _getAction(){
    var {action} = this.props.params;

    return (typeof action == "string")
      ? action.toLowerCase()
      : action;
  }

});


module.exports = ReactI18n.translate(['main'], {
  withRefs: false,
  wait: true
})(SecurityPage);
